import React from "react";
import "./HeroSection.css";

const ASSETS = "/images/intuuch";

function Decoration({ name, className }) {
  return <img className={className} src={`${ASSETS}/${name}`} alt="" aria-hidden="true" draggable="false" />;
}

export default function HeroSection({ appStoreUrl, contactUrl, privacyUrl, termsUrl }) {
  return (
    <section className="intuuch-launch">
      <header className="intuuch-header">
        <a className="intuuch-brand" href="/" aria-label="Intuuch home">
          <img src={`${ASSETS}/intuuch-logo.png`} alt="Intuuch" width="1878" height="330" />
        </a>
        <a className="intuuch-download" href={appStoreUrl}>Download</a>
      </header>

      <main className="intuuch-hero">
        <div className="intuuch-copy">
          <h1><span>Share plans.</span><span>Find your people.</span></h1>
          <p>Find people to do things with, share your plans,<br className="intuuch-desktop-break" /> and see what others are up for.</p>
          <a className="intuuch-store-link" href={appStoreUrl} aria-label="Download Intuuch on the App Store">
            <img src={`${ASSETS}/app-store-badge.svg`} alt="Download on the App Store" width="240" height="80" />
          </a>
        </div>

        <div className="intuuch-object intuuch-coffee" aria-hidden="true">
          <span className="intuuch-bubble">Coffee anyone?</span>
          <Decoration name="coffee.png" className="intuuch-art" />
          <Decoration name="accent-rays.svg" className="intuuch-rays" />
        </div>
        <div className="intuuch-object intuuch-headphones" aria-hidden="true">
          <span className="intuuch-bubble">Study break?</span>
          <Decoration name="headphones.png" className="intuuch-art" />
          <Decoration name="sparkle.svg" className="intuuch-sparkle" />
        </div>
        <div className="intuuch-object intuuch-cloud" aria-hidden="true">
          <Decoration name="cloud-mascot-3d.png" className="intuuch-art" />
          <span className="intuuch-bubble">Who’s up<br />for a walk?</span>
          <Decoration name="sparkle.svg" className="intuuch-sparkle" />
        </div>
        <div className="intuuch-object intuuch-basketball" aria-hidden="true">
         
          <Decoration name="basketball.png" className="intuuch-art" />
          <Decoration name="accent-rays.svg" className="intuuch-rays" />
        </div>
      </main>

      <Decoration name="checkerboard-ribbon.svg" className="intuuch-ribbon intuuch-ribbon-top" />
      <Decoration name="checkerboard-ribbon.svg" className="intuuch-ribbon intuuch-ribbon-bottom" />
      <footer className="intuuch-footer">
        {contactUrl && <a href={contactUrl}>Contact</a>}
        {privacyUrl && <a href={privacyUrl}>Privacy</a>}
        {termsUrl && <a href={termsUrl}>Terms</a>}
      </footer>
    </section>
  );
}
